import { createRouter, createWebHistory } from "vue-router";

import DataChartsModule from "@DataChartsModule";
import LoginModule from "@AccessModule/login";
import InitialLandingModule from "@DashboardModule";
import ErrorModule from "@ErrorModule";
import AdminModule from "@AdminModule"
import GenerateModule from "@GenerateModule"
import ViewTemplate from "@ViewTemplate"
import UserActivities from "@AdminModule/user-activities"

import { RouterViewComponent } from "@GlobalComponents"

const routes = [
    {
        path: '/',
        name: "login",
        component: LoginModule,
    },
    {
        path: '/report/dashboard',
        name: "initial-page",
        component: InitialLandingModule,
    },
    {
        path: '/error/:code',
        name: "error-page",
        component: ErrorModule,
    },
    {
        path: '/report/:dimension?/:attribute?/:type?/:metric?/:slug?',
        name: "permutations",
        component: DataChartsModule,
    },
    {
        path: '/template/:dimension?/:attribute?/:id?',
        name: "report",
        component: GenerateModule,
    },
    {
        path: '/generate/template/:uuid',
        name: "template_report",
        component: ViewTemplate,
    },
    {
        path: '/admin/dashboard/:type',
        component: RouterViewComponent,
        children: [
            {
                name: "admin",
                path: '',
                component: AdminModule,
            },
            {
                name: "aggregation-table",
                path: ':aggregation',
                component: AdminModule,
            },
            {
                name: "user-activities",
                path: 'activities',
                component: UserActivities,
            },

        ],
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

export default router;
